function product_carousel_action(button) {
    if(button.className == "recipe-carousel_next"){
        let carousel_selected = button.previousElementSibling.firstElementChild;
        let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
        resize(carousel_selected);
        let move_position = parseInt(carousel_selected.getAttribute("movePosition"));
        carousel_next(button, carousel_selected, actual_position, move_position);
    }
    else {
        let carousel_selected = button.nextElementSibling.firstElementChild;
        let actual_position = parseInt(carousel_selected.getAttribute("actualPosition"));
        let move_position = parseInt(carousel_selected.getAttribute("movePosition"));
        carousel_prev(button, carousel_selected, actual_position, move_position);
    }
}

function resize(carousel_selected){
    let move_position = 0;
    if(window.innerWidth < 1201 && window.innerWidth > 1024){
        move_position = 200;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 1025 && window.innerWidth > 768){
        move_position = 200;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 769 && window.innerWidth > 481){
        move_position = 200;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else if (window.innerWidth < 481){
        move_position = 200;
        carousel_selected.setAttribute("movePosition", move_position);
    }
    else {
        move_position = 200;
        carousel_selected.setAttribute("movePosition", move_position);
    }
}

function carousel_next(button_next, carousel_selected, actual_position, move_position) {
    const trackWidth = (carousel_selected.scrollWidth - carousel_selected.offsetWidth) * -1;
    if(actual_position > trackWidth){
        carousel_selected.style.transform = `translateX(${actual_position-(move_position)}px)`;
        actual_position += move_position*-1;
        carousel_selected.setAttribute("actualPosition", actual_position);    
    }
    if(actual_position < trackWidth){
        button_next.style.visibility = "hidden";
    }
    if(actual_position < 0){
        let button_prev = button_next.previousElementSibling.previousElementSibling;
        button_prev.style.visibility = "visible";
    }
}

function carousel_prev(button_prev, carousel_selected, actual_position, move_position) {
    const trackWidth = (carousel_selected.scrollWidth - carousel_selected.offsetWidth) * -1;
    if(actual_position < 0){
        carousel_selected.style.transform = `translateX(${actual_position+(move_position)}px)`;
        actual_position -= move_position*-1;
        carousel_selected.setAttribute("actualPosition", actual_position);
    }
    if(actual_position >= trackWidth){
        let button_next = button_prev.nextElementSibling.nextElementSibling;
        button_next.style.visibility = "visible";
    }
    if(actual_position == 0){
        button_prev.style.visibility = "hidden";
    }
}

function showCarouselButton() {
    let button_next = document.getElementsByClassName("recipe-carousel_next");
    let carousel = document.getElementsByClassName("recipe-content-carousel");
    for(i=0; i< carousel.length; i++){
        let carousel_width = 0;
        carousel_width = carousel[i].offsetWidth;
        if(carousel_width > carousel[i].scrollWidth) {
            button_next[i].style.visibility = "hidden";
        }
        else {
            if (button_next[i]) {
                button_next[i].style.visibility = "visible";
            }
        }
    }
}

function buttonDropdown(dropElement) {
    var sibling = dropElement.nextElementSibling;
    
    if(sibling.classList.contains('active')){
        dropElement.children[1].style.display = "block";
        dropElement.children[2].style.display = "none";
        sibling.style.display = "none";
        sibling.classList.remove('active');
    }
    else {
        dropElement.children[1].style.display = "none";
        dropElement.children[2].style.display = "block";
        sibling.style.display = "block";
        sibling.classList.add('active');
    }
}

function replaceBreadcrumb() {
    var occassionSelected = localStorage.getItem('occassionSelected');
    var dishtypeSelected = localStorage.getItem('dishtypeSelected');
    var productSelected = localStorage.getItem('productSelected');
    localStorage.removeItem("occassionSelected");
    localStorage.removeItem("dishtypeSelected");
    localStorage.removeItem("productSelected");
    if(productSelected != null){
        document.getElementById('product').innerHTML = '<a href="/collections/recipes?category='+  productSelected.replace(/\s/g, "") +'">'+  productSelected +'</a>';
    }
    if(occassionSelected != null){
        document.getElementById('occassion').innerHTML = '<a href="/collections/recipes?category='+  occassionSelected.replace(/\s/g, "") +'">'+  occassionSelected +'</a>';
    }
    if(dishtypeSelected != null){
        document.getElementById('dish-type').innerHTML = '<a href="/collections/recipes?category='+  dishtypeSelected.replace(/\s/g, "") +'">'+  dishtypeSelected +'</a>';;
    }
}

window.onload = showCarouselButton;
window.onload = replaceBreadcrumb;
window.onresize = showCarouselButton;